// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"39dbbddd","358":"de8f932f","548":"2a0f327c","551":"51ed2fcb","698":"361f0f34","828":"a6c43df2","950":"a8e3f756"}[chunkId] + ".chunk.js";
};